import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkLeadHasCase, getCaseIdFromLead, createCaseFromLead } from "../../../services/api";

const CaseActionButton = ({ leadId }) => {
  const [hasCase, setHasCase] = useState(false);
  const [caseId, setCaseId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the lead has an associated case
    const checkCase = async () => {
      try {
        const caseExists = await checkLeadHasCase(leadId);
        setHasCase(caseExists);
        
        if (caseExists) {
          const id = await getCaseIdFromLead(leadId);
          setCaseId(id);
        }
        
        setLoading(false);
      } catch (error) {
        console.error("Error checking case status:", error);
        setLoading(false);
      }
    };
    
    checkCase();
  }, [leadId]);

  const handleCreateCase = async () => {
    setCreating(true);
    try {
      const newCase = await createCaseFromLead(leadId);
      setCaseId(newCase.id);
      setHasCase(true);
      // Optionally navigate to the new case
      // navigate(`/cases/${newCase.id}`);
    } catch (error) {
      console.error("Error creating case:", error);
      alert("Failed to create case: " + error.message);
    } finally {
      setCreating(false);
    }
  };

  const handleViewCase = () => {
    navigate(`/cases/${caseId}`);
  };

  if (loading) {
    return (
      <button
        disabled
        className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-gray-100"
      >
        <svg className="animate-spin -ml-1 mr-2 h-3 w-3 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Loading...
      </button>
    );
  }

  if (hasCase) {
    return (
      <button
        onClick={handleViewCase}
        className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <svg className="-ml-0.5 mr-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
        </svg>
        View Case
      </button>
    );
  }

  return (
    <button
      onClick={handleCreateCase}
      disabled={creating}
      className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
    >
      {creating ? (
        <>
          <svg className="animate-spin -ml-1 mr-2 h-3 w-3 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Creating...
        </>
      ) : (
        <>
          <svg className="-ml-0.5 mr-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
          Add Case
        </>
      )}
    </button>
  );
};

export default CaseActionButton; 